/**
 * WHERE "GET HELP" GOES ON app.*, IN ONE PLACE.
 *
 * The same destination Book uses (apps/book/src/lib/support.ts): Product's
 * approved fallback is the support address until Marketing verifies a working
 * support page (`https://uselura.com/support` returned 404 on 2026-09-22).
 *
 * A bare `mailto:`, deliberately: no subject or body is prefilled, so no action
 * code, Account Link, token or address can ride along into a mail client by
 * accident. When the page exists, change it here and in Book together.
 */
export const SUPPORT_HREF = "mailto:support@uselura.com";
